var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_121_1188)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0005,
    r: 24,
    fill: "url(#paint0_linear_121_1188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0005,
    r: 23.6167,
    stroke: "url(#paint1_radial_121_1188)",
    strokeWidth: 0.766667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0005,
    r: 23.6167,
    stroke: "url(#paint2_radial_121_1188)",
    strokeWidth: 0.766667
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19L23.8906 24.2604C24.5624 24.7083 25.4376 24.7083 26.1094 24.2604L34 19M18 30H32C33.1046 30 34 29.1046 34 28V18C34 16.8954 33.1046 16 32 16H18C16.8954 16 16 16.8954 16 18V28C16 29.1046 16.8954 30 18 30Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_121_1188",
    x: -8.80029,
    y: -8.79981,
    width: 65.6006,
    height: 65.6006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.40015
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_121_1188"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_121_1188",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_1188",
    x1: -198.222,
    y1: -32.1995,
    x2: 22.3786,
    y2: 127.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_121_1188",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1991 46.2438) rotate(-140.546) scale(63.2869 43.4196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_121_1188",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-22.1333 -10.5995) rotate(26.5462) scale(60.4136 51.7265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.f6ea2ffb029952d8f95dbcb369c96d5d.svg";
export { ForwardRef as ReactComponent };